<template>
  <div
    class="child-branch-wrapper flex h-full"
    :class="`min-h-[${rowMinHeight}]`"
  >
    <em
      v-for="i in depth"
      :key="i"
      class="w-0"
      :class="{ 'pl-4 ml-2 flex': isChild }"
      :style="{
        ...branchIconStyle(i),
      }"
    >
    </em>
  </div>
</template>

<script setup lang="ts">
import { toRefs } from 'vue';
import useChildBranchIcons from '@/utilities/composables/useChildBranchIcons';

const props = withDefaults(
  defineProps<{
    depth: number;
    // eslint-disable-next-line vue/no-unused-properties
    depthSiblings: number[] | undefined;
    isChild: boolean;
    // eslint-disable-next-line vue/no-unused-properties
    lastItem: boolean;
    rowMinHeight?: string;
  }>(),
  {
    depth: 0,
    // used in useChildBranchIcons
    depthSiblings: () => [],
    isChild: false,
    lastItem: false,
    rowMinHeight: '40px',
  }
);

const { depth = 0, isChild = false, rowMinHeight = '40px' } = toRefs(props);

const { getBranchIconStyle } = useChildBranchIcons();

const branchIconStyle = (i, propsParam = props) => getBranchIconStyle(i, propsParam);
</script>
